function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { applyProposal, uploadShippingCSV, emulateProgressStep, moveToStep, applyKSFlow } from '../../redux/kickstarter-shipping/kickstarter-shipping.actions';
import { PROGRESS_LOADING } from '../../redux/kickstarter-shipping/kickstarter-shipping-constants';
import KickstarterShippingPopup from '../../components/popups/kickstarter-shipping-popup/';
class KickstarterShipping extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onAddToOrder", () => {
      const {
        orderToken,
        kickstarterShipping: {
          items
        }
      } = this.props;
      const ids = items.map(item => item._id);
      this.props.onAddToOrder(orderToken, ids);
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      onProgressStep
    } = this.props;
    if (nextProps.kickstarterShipping.step === PROGRESS_LOADING) {
      setTimeout(onProgressStep, 60);
    }
  }
  render() {
    const {
      kickstarterShipping,
      onApproveProposal,
      onCSVUpload,
      onChangeStep,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(KickstarterShippingPopup, _extends({}, kickstarterShipping, {
      onApproveProposal: onApproveProposal,
      onCSVUpload: onCSVUpload,
      onChangeStep: onChangeStep,
      onClose: onClose,
      onAddToOrder: this.onAddToOrder
    }));
  }
}
const mapStateToProps = state => ({
  kickstarterShipping: state.kickstarterShipping,
  orderToken: state.cart.orderToken
});
const mapDispatchToProps = dispatch => ({
  onApproveProposal: () => {
    dispatch(applyProposal());
  },
  onCSVUpload: ({
    file
  }) => {
    dispatch(uploadShippingCSV({
      file
    }));
  },
  onProgressStep: () => {
    dispatch(emulateProgressStep());
  },
  onChangeStep: step => {
    dispatch(moveToStep({
      step
    }));
  },
  onAddToOrder: (orderToken, ksFlowItems) => {
    dispatch(applyKSFlow({
      orderToken,
      ksFlowItems
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(KickstarterShipping);